import CheckmarkIllustration from "../../assets/img/checkmark-illustration.svg";
import EmailIllustration from "../../assets/img/email-illustration.svg";
import PhoneIllustration from "../../assets/img/phone-illustration.svg";
import useEarlyShopping from "../../features/shopping/use-early-shopping";
import { Button, Typography } from "@uhc-tempo/components";

const { H1, Paragraph } = Typography;

export default function ShoppingConfirmation(props) {
  const earlyShopping = useEarlyShopping();

  return (
    <section className="fluid-container page-main__fill ua-padding-jumbo-vertical ua-bg-primary-one shopping-confirmation">
      <div className="ua-grid ua-grid-gap-2-sm ua-grid-gap-3-lg ua-grid-cols-12">
        <div
          className={
            earlyShopping && earlyShopping.includeEarlyShopperMessage
              ? "ua-col-span-3-8-md ua-col-span-5-lg shopping-confirmation__grid-padding"
              : "ua-col-span-3-8-md ua-col-span-4-6-lg shopping-confirmation__grid-padding"
          }
        >
          <div className="ua-bg-primary-three ua-border ua-border-radius-sm ua-border-color-gray-four shopping-confirmation__card-padding">
            <div className="ua-margin-auto ua-text-center">
              {earlyShopping && earlyShopping.includeEarlyShopperMessage ? (
                <H1
                  className="ua-margin-jumbo-bottom ua-margin-lg-top ua-font-size-xlg"
                  headingStyle={2}
                >
                  Nice job shopping early!
                </H1>
              ) : (
                <>
                  <img
                    src={CheckmarkIllustration}
                    alt="Thumbs up"
                    width="64"
                    height="64"
                  />
                  <H1
                    className="ua-margin-jumbo-bottom ua-margin-lg-top ua-font-size-xlg"
                    headingStyle={2}
                  >
                    You&apos;re all set!
                  </H1>
                </>
              )}
            </div>
            {earlyShopping && earlyShopping.includeEarlyShopperMessage ? (
              <div className="shopping-early-shopping-message ua-margin-lg-bottom ua-padding-xxjumbo-horizontal">
                <Paragraph className="ua-font-size-h4">
                  <strong>Just one more step</strong> - we&apos;ll email you a
                  confirmation with a link to choose your 5 bonus gifts!
                </Paragraph>
              </div>
            ) : (
              <div className="shopping-confirmation__content">
                <Paragraph className="ua-text-primary-one ua-font-weight-bold ua-font-size-h6 ua-margin-lg-bottom">
                  What&apos;s next?
                </Paragraph>
                <div className="ua-display-flex ua-grid-gap-2-sm ua-align-items-flex-start">
                  <img
                    src={EmailIllustration}
                    alt="Thumbs up"
                    width="48"
                    height="48"
                  />
                  <Paragraph>
                    <strong>Keep an eye on your inbox.</strong>
                    <br />
                    You&apos;ll be receiving a shopping completed confirmation
                    email.
                  </Paragraph>
                </div>
                <div className="ua-display-flex ua-grid-gap-2-sm ua-margin-lg-top ua-align-items-flex-start">
                  <img
                    src={PhoneIllustration}
                    alt="Thumbs up"
                    width="48"
                    height="48"
                  />
                  <Paragraph>
                    <strong>Your UA Advocate will reach out soon.</strong>
                    <br />
                    We&apos;re here to help you unlock the exciting potential of
                    your perks.
                  </Paragraph>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
